import { batch, useSignal } from '@preact/signals-react'
import { TextFieldSeeker } from '@ui-seeker/core'
import React from 'react'
import { useAppFormHandler } from '@hooks'
import { formData } from '@signals'

export default function NewCategorySelector() {
	const { categoryOptions, onCategoryOptionsChange } = useAppFormHandler('categoryOptions')
	const newCategory = useSignal(null)

	return <TextFieldSeeker
		value={newCategory.value || ''}
		onChange={e => batch(() => {
			const targetValue = e.target.value
			const existingOption = categoryOptions.find(({ label }) => label === targetValue)
			newCategory.value = targetValue

			if (!targetValue) {
				onCategoryOptionsChange(categoryOptions.slice(0, -1))
			} else if (existingOption) {
				formData.value = { ...formData.value, idCategory: existingOption?.value }
			} else {
				onCategoryOptionsChange([...categoryOptions.slice(0, -1), { label: targetValue, value: targetValue }])
			}
			formData.value = { ...formData.value, idCategory: targetValue }
		})}
		placeholder="Add new Category"
	/>

}

